var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'分类管理',path:'/shop/article/cate'},
    {title:'文章管理',path:'/shop/article/page'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }